import {
  Button,
  InputStructure,
  InputWithIcons
} from '@tablecheck/tablekit-react';
import { useMachine } from '@xstate/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { machine } from 'pages/SingleSignOn/machine';
import { Checkmark, Close } from 'pages/SingleSignOn/styled';
import { doRedirect } from 'utils/auth';
import { STORAGE_KEY_SSO_PROVIDER } from 'utils/constants';
import { AuthFormWrapper } from 'utils/form.styles';
import { onInputFocus } from 'utils/input';

export function SingleSignOn(): JSX.Element {
  const [t] = useTranslation();
  const [state, send] = useMachine(() =>
    machine.withContext({
      inputValue: localStorage.getItem(STORAGE_KEY_SSO_PROVIDER) || '',
      data: null,
      error: null
    })
  );
  const {
    context: { data, error, inputValue }
  } = state;
  const isDirty = !state.matches('idle');
  const isSearching = state.matches('searching');

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (data?.url) {
      localStorage.setItem(STORAGE_KEY_SSO_PROVIDER, data.key);
      doRedirect(data.url);
    }
  };

  return (
    <AuthFormWrapper onSubmit={onSubmit}>
      <h2>{t('forms.sso')}</h2>
      <InputStructure
        name="email"
        label={t('forms.company_or_email')}
        input={
          <InputWithIcons data-stretch>
            <input
              id="provider"
              value={inputValue}
              onChange={(event) => {
                send({ type: 'Search', value: event.target.value });
              }}
              onFocus={onInputFocus}
              placeholder={t('forms.company_or_email')}
              required
            />
            {/* eslint-disable-next-line no-nested-ternary */}
            {isDirty && inputValue ? (
              data ? (
                <Checkmark size={16} />
              ) : (
                <Close size={16} />
              )
            ) : null}
          </InputWithIcons>
        }
      />
      <Button
        data-size="large"
        disabled={isSearching || !!error || !data}
        aria-busy={isSearching}
        type="submit"
        aria-label="Submit button"
      >
        {t('forms.sign_in')}
      </Button>
    </AuthFormWrapper>
  );
}
